import Data from '../Data';

// Action Types

export const RequestWidgetData = 'canny/changelog_widget/request_widget_data';
export const WidgetDataLoaded = 'canny/changelog_widget/widget_data_loaded';
export const WidgetDataError = 'canny/changelog_widget/widget_data_error';

// Actions

function requestWidgetData() {
  return {
    timestamp: Date.now(),
    type: RequestWidgetData,
  };
}

function widgetDataLoaded(result) {
  return {
    result,
    timestamp: Date.now(),
    type: WidgetDataLoaded,
  };
}

function widgetDataError(error) {
  return {
    error,
    timestamp: Date.now(),
    type: WidgetDataError,
  };
}

// Action Creators

function fetchWidgetData(companyID, ssoToken, labelIDs) {
  return (dispatch, getState) => {
    const cookies = getState().cookies;
    return Promise.all([
      Data.fetch(
        {
          result: {
            input: {
              companyID,
              labelIDs,
              ssoToken,
            },
            query: Data.queries.changelogWidget,
          },
        },
        cookies,
        (error, data) => {
          return gotResult(dispatch, error, data);
        },
      ),
    ]);
  };
}

export function loadWidgetData(companyID, ssoToken, labelIDs) {
  return (dispatch, getState) => {
    if (shouldFetchWidgetData(getState())) {
      if (!companyID) {
        return dispatch(widgetDataError('Missing companyID'));
      }

      dispatch(requestWidgetData());
      return dispatch(fetchWidgetData(companyID, ssoToken, labelIDs));
    } else if (isFetchingWidgetData(getState())) {
      return waitForResult();
    }

    return Promise.resolve();
  };
}

export function reloadWidgetData(companyID, ssoToken, labelIDs) {
  return (dispatch) => {
    return dispatch(fetchWidgetData(companyID, ssoToken, labelIDs));
  };
}

// Helper Functions

function shouldFetchWidgetData(state) {
  return !state.changelogWidget;
}

function isFetchingWidgetData(state) {
  return !!state.changelogWidget.loading;
}

// Callback Queue

const resultCallbacks = [];

function waitForResult() {
  return new Promise((resolve, reject) => {
    resultCallbacks.push(() => {
      resolve();
    });
  });
}

function gotResult(dispatch, error, data) {
  var resultAction;
  if (data && data.result) {
    resultAction = widgetDataLoaded(data.result);
  } else {
    resultAction = widgetDataError(error);
  }

  return Promise.all([dispatch(resultAction)]).then(() => {
    resultCallbacks.forEach((resultCallback) => {
      resultCallback();
    });
    resultCallbacks.length = 0;
  });
}
